import { useState, useCallback, useRef } from "react";
import { driver } from "driver.js";
import "driver.js/dist/driver.css";

import { waitForElement } from "../helpers/global-helpers";


const useInsightsTour = ({ setUseTourData, setAnalyticsCategory }) => {
  const [driverObj, setDriverObj] = useState(null);
  const hasStarted = useRef(false); // Prevent re-renders


  const startInsightsTour = useCallback(() => {
    if (!hasStarted.current) {
      setUseTourData(true)
      setAnalyticsCategory('stats-overview')// Run only the first time per session
      hasStarted.current = true;
    }

    const resetState = () => {
      setUseTourData(false);
      setAnalyticsCategory('stats-overview');
      hasStarted.current = false;
    }

    const tour = driver({
      showProgress: true,
      allowClose: true,
      showButtons: ["next"],
      overlayColor: "rgba(0, 0, 0, 0.5)",
      popoverOffset: 25,
      onDestroyed: () => resetState(),
      onReset: () => resetState(),
      steps: [
        {
          element: '[data-driver="insights-tour-step-1"]',
          popover: {
            title: "Total time spent",
            description: `
            <div>
              <div style="margin-bottom: 1em;">Gives you an idea how much your guest members are using this Room</div>
            </div>`
          },
        },

        {
          element: '[data-driver="insights-tour-step-2"]',
          popover: {
            title: "Total Room views",
            description: "This gives you an indication on how many times guest members have visited your Room."
          },
        },
        {
          element: '[data-driver="insights-tour-step-3"]',
          popover: {
            title: "Total page views",
            description: `
            <div>
              <div style="margin-bottom: 1em;">
                 You also get to understand how many pages are viewed since the Room has been published.
              </div>
              <div>
             It gives a good indication on how useful your content in the Room is.
               </div>
            </div>`,
          },
        },
        {
          element: '[data-driver="insights-tour-step-4"]',
          popover: {
            title: "Engagement level", description: `
            <div>
              <div style="margin-bottom: 1em;">
                 Based on your guest members' activities, we give you a sense on how engaged they are with your team.
              </div>
              <div>
             The level is determined by a combination of factors, such as post creation, visits, views, and more. 
               </div>
            </div>`,
          },
        },
        {
          element: '[data-driver="insights-tour-step-5"]',
          popover: {
            title: "Behavioral insights", description: `
              <div>
              <div style="margin-bottom: 1em;">Actions speak louder than words. Deduce what your guest members really thinks from their actions.</div>
              <div>For example, here, it appears Ruth had recently spent a lot of time on the Pricing page. This means further discussions on Pricing is probably needed!</div>
            </div>`
            ,
            onNextClick: async () => {
              if (setAnalyticsCategory) {
                setAnalyticsCategory('guest-stats');
                await waitForElement('[data-driver="insights-tour-step-6"]');
                tour.moveNext();
              }
            }
          },
        },
        {
          element: '[data-driver="insights-tour-step-6"]',
          popover: {
            title: "Insights into each guest member",
            description: `You can get a sense of who amongst your Guest group is the most engaged with you, and when their last visit is. The sense of recent engagement normally suggests how hot your lead is towards your propositions.`,
            onNextClick: async () => {
              if (setAnalyticsCategory) {
                setAnalyticsCategory('page-stats');
                await waitForElement('[data-driver="insights-tour-step-7"]');
                tour.moveNext();
              }
            }
          },
        },
        {
          element: '[data-driver="insights-tour-step-7"]',
          popover: {
            title: "Insights into page relevance",
            description: `
            <div>
              <div style="margin-bottom: 1em;">
                 This section shows your how interested members, as a group, are in the page. 
              </div>
              <div>
            For our supporters using the paid Pro plan, you are also able to see how long each user spent in each page since the Room was published.
               </div>
            </div>`
          },
        },
      ],
    });

    setDriverObj(tour);
    tour.drive();

  }, [setUseTourData, setAnalyticsCategory]);

  const stopInsightsTour = useCallback(() => {
    if (driverObj) {
      driverObj.stop();
    }
  }, [driverObj]);

  return { startInsightsTour, stopInsightsTour };
};

export default useInsightsTour